import { animate, style, transition, trigger } from '@angular/animations';
import { AfterViewInit, Component, computed, ElementRef, OnInit, signal, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgSelectComponent } from '@ng-select/ng-select';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ADD_ROUTE, ADMIN_CLUSTER_LOGS_ROUTE, MY_LOGS_ROUTE } from 'app/app-routing.constants';
import { SitesService } from '@shared/services/sites/sites.service';
import { HostModeService } from '@shared/services/hostMode.service';
import { ToastrService } from '@shared/services/toastr.service';
import _ from 'lodash';
import { distinctUntilChanged, firstValueFrom, fromEvent, Subject, switchMap } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';
import {
  ACL_SITE_ACTIONS,
  ACL_SITE_EDIT,
  AuthService,
  SHARE_ACCESS_RIGHT_ADMIN,
  SHARE_ACCESS_RIGHT_VIEW,
} from '@shared/services/auth.service';
import {
  OrganizationSiteService,
  GetSites as Site,
  SiteDetail,
  SiteRef,
  SiteShare,
} from '@shared/services/organization-site.service';
import { ModalBasicComponent } from '@shared/components/modal-basic/modal-basic.component';
import { KeyOfType } from '@shared/utils/type-utils';
import { isValidEmail, isValidOrganizationCode } from '@shared/validators/validators';
import { SiteService, SiteStatus } from '@shared/services/site.service';
import { ClusterUidAndName } from '@shared/models/cluster';
import { OrganizationTagsService } from '@shared/services/organization-tags.service';
import { CONTEXT } from '@shared/models/ContextSiteModel';
import { CardComponent } from '@shared/components/card/card.component';
import { FormsModule } from '@angular/forms';
import { KeyValuePipe, NgClass, NgFor, NgIf, NgStyle } from '@angular/common';
import { HelpComponent } from '@shared/components/help/help.component';
import { SiteStatusComponent } from '@shared/components/site-status/site-status.component';
import { ActivationCdnLabelComponent } from '@shared/components/label/activation-cdn-label/activation-cdn-label.component';
import { AuditModeLabelComponent } from '@shared/components/label/audit-mode-label/audit-mode-label.component';
import { SitePassthroughModeLabelComponent } from '@shared/components/label/site-passthrough-mode-label/site-passthrough-mode-label.component';
import { CertificateErrorLabelComponent } from '@shared/components/label/certificate-error-label/certificate-error-label.component';
import { HostModeLabelComponent } from '@shared/components/label/host-mode-label/host-mode-label.component';
import { ManagedServiceLabelComponent } from '@shared/components/label/managed-service-label/managed-service-label.component';
import { BadgeOrganizationComponent } from '@shared/components/badge-organization/badge-organization.component';
import { TimestampCellComponent } from '@shared/components/timestamp-cell/timestamp-cell.component';
import { NgxPaginationModule } from 'ngx-pagination';
import { ModalBasicComponent as ModalBasicComponent_1 } from '../../shared/components/modal-basic/modal-basic.component';
import { LabelShareRoleComponent } from '@shared/components/label-share-role/label-share-role.component';
import { SiteTagsComponent } from '@shared/components/tags/site-tags.component';
import { TranslateLabelPipe } from '@shared/pipe/filter.pipe';

@Component({
  selector: 'app-my-sites',
  templateUrl: './my-sites.component.html',
  styleUrls: ['./my-sites.component.scss', './site-status.scss'],
  animations: [
    trigger('fadeInOutTranslate', [
      transition(':enter', [style({ opacity: 0 }), animate('400ms ease-in-out', style({ opacity: 1 }))]),
      transition(':leave', [style({ transform: 'translate(0)' }), animate('400ms ease-in-out', style({ opacity: 0 }))]),
    ]),
  ],
  imports: [
    CardComponent,
    FormsModule,
    NgFor,
    NgIf,
    HelpComponent,
    SiteStatusComponent,
    ActivationCdnLabelComponent,
    AuditModeLabelComponent,
    SitePassthroughModeLabelComponent,
    CertificateErrorLabelComponent,
    HostModeLabelComponent,
    ManagedServiceLabelComponent,
    BadgeOrganizationComponent,
    TimestampCellComponent,
    NgClass,
    NgxPaginationModule,
    ModalBasicComponent_1,
    NgSelectComponent,
    LabelShareRoleComponent,
    NgStyle,
    SiteTagsComponent,
    KeyValuePipe,
    TranslatePipe,
    TranslateLabelPipe,
  ],
})
export class MySitesComponent implements OnInit, AfterViewInit {
  @ViewChild('AddSiteModal') addSiteModal: any;
  @ViewChild('addDomainModal') addDomainModal: any;
  @ViewChild('modalShare') modalShare: ModalBasicComponent;
  @ViewChild('tagInput') tagInput: any;
  @ViewChild('tagInputUrlExcept') tagInputUrlExcept: any;
  @ViewChild('modalDelete') modalDelete: any;
  @ViewChild('modalMultipleAuditPanic') modalMultipleAuditPanic: any;
  @ViewChild('modalMultipleShares') modalMultipleShares: any;
  @ViewChild('modalMultipleDeletes') modalMultipleDeletes: any;
  @ViewChild('modalMultipleCertificat') modalMultipleCertificat: any;
  @ViewChild('modalMultipleTags') modalMultipleTags: any;
  @ViewChild('loadPkcs12') loadPkcs12: any;
  @ViewChild('addMultiShareInput') addMultiShareInput: NgSelectComponent;
  @ViewChild('addShareInput') addShareInput: NgSelectComponent;
  @ViewChild('searchInputRef') searchInputRef: ElementRef;

  lang: string;

  adminClusterView: boolean;

  currentShares: SiteShare[] = [];
  shareInput = [];
  lastShareInput = '';
  shareTooltip = false;
  sharedRole = SHARE_ACCESS_RIGHT_VIEW;
  multipleSharedRole = SHARE_ACCESS_RIGHT_VIEW;

  sites: SiteVM[] = [];
  clusters: ClusterUidAndName[] = [];
  selectedSites = signal(new Map<string, Site>());
  tags = [];
  selectedTags = [];
  selectedSite: Site;
  siteToDelete: SiteDetail;
  filters: MySitesFilters = {};

  p12File: any = null;
  p12Password = '';
  makeCertificateActive = true;

  index = 0;
  pageSize = 20;
  total = 0;

  sitesInRefresh = false;
  refreshingSite: string;

  confirmDelete = false;

  sub: any;

  siteStatuses: SiteStatus[] = [];

  ACL_SITE_EDIT = ACL_SITE_EDIT;

  shareRoles = [SHARE_ACCESS_RIGHT_ADMIN, SHARE_ACCESS_RIGHT_VIEW];

  isSameCluster = computed(() =>  {
    console.log('isSameCluster?')
    return (
      _([...this.selectedSites().values()])
        .map((s) => s.cluster.uid)
        .uniq()
        .size() == 1
    );
  });

  get state(): MySitesState {
    return {
      index: this.index,
      ...this.filters,
    };
  }

  triggerLoadSites = new Subject<void>();

  protected readonly userFeatures = new Set(this.auth.user.features);

  constructor(
    public auth: AuthService,
    private toastr: ToastrService,
    private sitesService: SitesService,
    private translate: TranslateService,
    public hostModeService: HostModeService,
    private organizationSiteService: OrganizationSiteService,
    private organizationTagsService: OrganizationTagsService,
    private siteService: SiteService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.route.data.subscribe(() => {
      const mySitesState = this.router.getCurrentNavigation()?.extras?.state?.mySitesState;
      if (mySitesState) this.parseState(mySitesState);
    });
  }

  ngOnInit() {
    this.lang = this.auth.getCurrentLanguage();

    this.route.data.subscribe(async (v) => {
      this.adminClusterView = v.adminClusterView;
      if (this.adminClusterView && v.clusters) {
        this.clusters = v.clusters;
      } else {
        if (!this.sitesService[CONTEXT].store.sitesList.length) {
          await this.sitesService.load(CONTEXT);
        }
        this.tags = this.sitesService[CONTEXT].store.tags;
        this.clusters = this.sitesService[CONTEXT].store.clusters;
      }
    });

    this.getSiteStatuses();
  }

  ngAfterViewInit(): void {
    this.triggerLoadSites.pipe(switchMap(() => this.getSites())).subscribe((res) => {
      this.total = res.count;
      this.sites =
        res.items.map((site) => ({
          ...site,
          canEdit: site.accessRights.includes(ACL_SITE_ACTIONS.EDIT),
          canShare: site.accessRights.includes(ACL_SITE_ACTIONS.SHARE),
          canDelete: site.accessRights.includes(ACL_SITE_ACTIONS.DELETE),
          canDoMoreThanView: site.accessRights.some((access) => access != ACL_SITE_ACTIONS.VIEW),
        })) || [];
    });

    fromEvent(this.searchInputRef.nativeElement, 'keyup')
      .pipe(
        debounceTime(300),
        map(() => this.filters.search),
        distinctUntilChanged(),
      )
      .subscribe(() => this.refreshSites());

    this.loadSites();
  }

  refreshSites() {
    this.index = 0;
    this.loadSites();
  }

  getSiteStatuses() {
    this.siteService.getStatuses().subscribe((statuses) => (this.siteStatuses = statuses));
  }

  async updateSelectedSitesBooleanProp(prop: KeyOfType<Site, boolean>, value: boolean) {
    let siteInError: Site;

    for (const site of this.selectedSites().values()) {
      try {
        const updatedSite = await firstValueFrom(this.updateSiteBooleanProp(site, prop, value));
      } catch (error) {
        siteInError = site;
        break;
      }
    }

    if (!siteInError) {
      this.toastr.success('ModifiedSitesSuccess');
      this.selectedSites().forEach((host) => {
        host[prop] = value;
      });
    } else {
      this.toastr.error(['ImpossProv', { siteName: siteInError.domainName }]);
    }
  }

  async allDelete() {
    try {
      for (const site of this.selectedSites().values()) {
        await firstValueFrom(this.organizationSiteService.deleteSite(site.domainName));
      }

      this.toastr.success('DomainsSupp');
      this.modalMultipleDeletes.hide();
      this.selectedSites.set(new Map());
      this.refreshSites();
    } catch (error) {
      this.toastr.error('Erreur');
    }
  }

  handleShareType(event) {
    this.lastShareInput = event.term;
  }

  handleShareBlur() {
    if (this.lastShareInput) {
      this.shareInput = [...this.shareInput, { label: this.lastShareInput }];
      this.lastShareInput = '';
    }
  }

  validateSharesInput(emails) {
    return emails.every((e) => isValidEmail(e) || isValidOrganizationCode(e));
  }

  closeMultipleShares() {
    this.modalMultipleShares.hide();
    this.shareInput = [];
  }

  updateSiteBooleanProp(site: Site, prop: KeyOfType<Site, boolean>, value: boolean) {
    return this.organizationSiteService.patchSite(site.domainName, { [prop]: value });
  }

  toggleSiteBooleanProp(site: Site, prop: KeyOfType<Site, boolean>) {
    this.updateSiteBooleanProp(site, prop, !site[prop]).subscribe((updatedSite) => {
      site[prop] = updatedSite[prop];
      this.toastr.success('SiteModifieSucc');
    });
  }

  changePage(page: number) {
    this.index = page - 1;
    this.triggerLoadSites.next();
  }

  getSites() {
    if (this.adminClusterView) {
      return this.organizationSiteService.getAdminClusterSites(this.index, this.pageSize, this.getSearchParameters());
    } else {
      return this.organizationSiteService.getSites(this.index, this.pageSize, this.getSearchParameters());
    }
  }

  loadSites() {
    this.triggerLoadSites.next();
  }

  getSearchParameters() {
    let data = {};
    if (this.filters.search) {
      const searchTerm = this.filters.search;
      data['ownerEmail'] = searchTerm;
      data['owner'] = searchTerm;
      data['originServer'] = searchTerm;
      data['domainName'] = searchTerm;
      data['ownerParam'] = { operator: '%%' };
      data['ownerEmailParam'] = { operator: '%%' };
      data['originServerParam'] = { operator: '%%' };
      data['domainNameParam'] = { operator: '%%' };
    }

    if (this.filters.clusterUid) {
      data['cluster'] = this.filters.clusterUid;
    }

    if (this.filters.status) {
      data['status'] = this.filters.status;
    }

    if (this.filters.tag) {
      data['tags'] = [{ tag: this.filters.tag }];
    }

    return data;
  }

  showSharedHosts(site: Site) {
    if (!this.hostModeService.isAdvanced(site.mode)) {
      return this.hostModeService.promptSubscribeToMode('SiteModeNotEnabled.advanced');
    }

    this.selectedSite = site;
    this.currentShares = site.shares;
    this.modalShare.show();
    setTimeout(() => this.addShareInput.focus(), 1);
  }

  toggleSelected(event, site: Site) {
    console.log('toggleSelected()', site, this.selectedSites())
    if (event.target.checked) {
      this.selectedSites().set(site.domainName, site);
    } else {
      this.selectedSites().delete(site.domainName);
    }
    this.selectedSites.update(x => new Map(x));
  }

  allEnabled<K extends keyof Site>(prop: K, value: Site[K]) {
    return [...this.selectedSites().values()].every((site) => site[prop] == value);
  }

  async showModalDelete(site: Site) {
    this.siteToDelete = await firstValueFrom(this.organizationSiteService.getSite(site.domainName));
    this.modalDelete.show();
  }

  showModalMultipleShares() {
    this.modalMultipleShares.show();
    setTimeout(() => this.addMultiShareInput.focus(), 1);
  }

  canMultipleShare(): boolean {
    return [...this.selectedSites().values()].some((site) => this.canShare(site));
  }

  canMultipleDelete(): boolean {
    return [...this.selectedSites().values()].some((site) => site.accessRights.includes('DELETE'));
  }

  canMultipleEdit(): boolean {
    return [...this.selectedSites().values()].some((site) => site.accessRights.includes('EDIT'));
  }

  onPasteShare(event) {
    const value = event.clipboardData.getData('text/plain');

    if (value != null && value.match(/[,;]/)) {
      event.preventDefault();
      const split = value.split(/[,;]/);
      split.forEach((s) => {
        if (s != '') {
          return (this.shareInput = [...this.shareInput, { label: s.trim() }]);
        }
      });
      event.target.value = '';
    }
  }

  async allCreateShare() {
    let recipients = [...new Set(this.shareInput.map((e) => e.label.trim()))];

    if (!this.validateSharesInput(recipients)) {
      return this.toastr.error('OneOfInvalidEmailOrCode');
    }

    const sitesToShare = [...this.selectedSites().values()].filter((site) => this.canShare(site));

    for (const site of sitesToShare) {
      for (const recipient of recipients) {
        try {
          await this.postCreateShare(site.domainName, recipient, this.multipleSharedRole);
        } catch (error) {
          return this.toastr.error(recipient + ' : ' + this.translate.instant(error?.error?.error || 'Erreur'));
        }
      }
    }
    this.loadSites();
    this.shareInput = [];

    this.toastr.success('Les sites ont été partagés avec succès');
  }

  async confirmCreateShare() {
    let recipients = [...new Set(this.shareInput.map((e) => e.label.trim()))];

    if (!this.validateSharesInput(recipients)) {
      return this.toastr.error('OneOfInvalidEmailOrCode');
    }

    for (const recipient of recipients) {
      let res: any = null;
      try {
        res = await this.postCreateShare(this.selectedSite.domainName, recipient, this.sharedRole);
      } catch (error) {
        return this.toastr.error(error?.error?.error || 'Erreur');
      }
      this.currentShares.push(res);
    }
    this.shareInput = [];
    this.toastr.success('Les sites ont été partagés avec succès');
  }

  async postCreateShare(siteName: string, recipient, role) {
    return await firstValueFrom(this.organizationSiteService.share(siteName, recipient, role));
  }

  async deleteShare(siteName, recipient, index) {
    await firstValueFrom(this.organizationSiteService.deleteShare(siteName, recipient));
    this.loadSites();
    this.currentShares.splice(index, 1);
    this.toastr.success('PartageSuppressionSucces');
  }

  deleteSite(siteName: string) {
    this.organizationSiteService.deleteSite(siteName).subscribe({
      next: () => {
        this.sitesService.purgeContext();
        this.modalDelete.hide();
        this.toastr.success('DomainSupp');
        this.loadSites();
      },
      error: () => this.toastr.error('ImpossibleSuppressionDomaine'),
    });
  }

  async multipleRefreshStatus() {
    this.sitesInRefresh = true;
    let hasError = false;

    for (const site of this.selectedSites().values()) {
      try {
        await firstValueFrom(this.refresh(site.domainName));
      } catch (error) {
        hasError = true;
        break;
      }
    }

    if (!hasError) {
      this.toastr.success(['StatusesUpdated', { n: this.selectedSites().size }]);
    } else {
      this.toastr.error();
    }

    this.loadSites();
    this.sitesInRefresh = false;
  }

  multipleSetSites() {
    const [first] = this.selectedSites().values();
    this.track(first.cluster.name, [...this.selectedSites().keys()]);
  }

  refreshStatus(site: Site) {
    this.refreshingSite = site.domainName;

    this.refresh(site.domainName).subscribe({
      next: () => {
        this.toastr.success('StatusUpdated');
        this.loadSites();
      },
      complete: () => {
        this.refreshingSite = null;
      },
      error: () => {
        this.refreshingSite = null;
      },
    });
  }

  refresh(siteRef: SiteRef) {
    return this.organizationSiteService.refreshStatus(siteRef);
  }

  handlePkcs12(files: FileList) {
    const file = files.item(0) as File;
    this.p12File = file;
  }

  handleKeyEnterP12(event) {
    event.preventDefault();
    this.uploadP12();
  }

  async uploadP12() {
    let hasError = false;

    for (const site of this.selectedSites().values()) {
      try {
        const res: any = await firstValueFrom(
          this.organizationSiteService.uploadP12(site.domainName, {
            p12Data: this.p12File,
            p12Password: this.p12Password,
            makeActive: this.makeCertificateActive,
          }),
        );
        this.toastr.success(['CertificatAjoutSucces', site]);
      } catch (error) {
        hasError = true;
        break;
      }
    }

    if (!hasError && this.selectedSites().size > 1) {
      this.toastr.success(['CertificatsAjoutSucces', { n: this.selectedSites().size }]);
    }

    this.modalMultipleCertificat.hide();
    this.loadSites();
    this.p12Password = '';
    this.loadPkcs12.nativeElement.value = '';
    this.p12File = null;
  }

  isValidIpv6(string) {
    return string.match(
      /^(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))$/,
    );
  }

  pushTags(event) {
    this.selectedTags = event;
  }

  createTags() {
    this.organizationTagsService
      .addTags({
        sites: [...this.selectedSites().values()].map((s) => s.domainName),
        tags: this.selectedTags,
      })
      .subscribe(() => {
        this.toastr.success();
        this.modalMultipleTags.hide();
        this.tags = [];
        this.sitesService.purgeContext();
        this.refreshTags();
        this.loadSites();
      });
  }

  async refreshTags() {
    const newTags = await this.sitesService.loadTags();
    this.tags = _.uniq([...this.tags, ...newTags]);
  }

  selectAll() {
    const sites = this.adminClusterView ? this.sites : this.sites.filter((site) => site.canDoMoreThanView);
    sites.forEach((site) => this.selectedSites().set(site.domainName, site));
  }

  setMode(site: Site, event) {
    this.organizationSiteService.patchSite(site.domainName, { mode: event.target.value }).subscribe({
      next: (updatedSite) => {
        this.loadSites();
        this.toastr.success();
      },
      error: () => {
        event.target.value = site.mode;
      },
    });
  }

  toggleDdosProtection(site: Site) {
    this.toggleSiteBooleanProp(site, 'ddosProtection');
  }

  canShare(site: Site): boolean {
    return this.hostModeService.isAdvanced(site.mode) && site.accessRights.includes('SHARE');
  }

  track(clusterName: string, sites: string[]) {
    this.router.navigate([this.adminClusterView ? ADMIN_CLUSTER_LOGS_ROUTE : MY_LOGS_ROUTE], {
      state: { sites, clusterName },
    });
  }

  editSite(site: string): void {
    this.router.navigate([site], { relativeTo: this.route, state: { mySitesState: this.state } });
  }

  addSite() {
    this.router.navigate([ADD_ROUTE], { relativeTo: this.route, state: { mySitesState: this.state } });
  }

  parseState(mySitesState: MySitesState) {
    const { index, ...filters } = mySitesState;
    this.filters = filters;
    this.index = index;
  }
}

export type MySitesFilters = Partial<{
  tag: string;
  status: string;
  clusterUid: number;
  search: string;
}>;

export type MySitesState = MySitesFilters & {
  index: number;
};

type SiteVM = Site & {
  canEdit: boolean;
  canShare: boolean;
  canDelete: boolean;
  canDoMoreThanView;
};
